import { render } from "./IconEmoji.vue?vue&type=template&id=0f17ae40"
import script from "./IconEmoji.vue?vue&type=script&lang=js"
export * from "./IconEmoji.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__